import axios from 'axios'
var baseUrl = 'https://weixin.kuding.cn/';
// var baseUrl = 'http://192.168.0.110:8800/';
const service = axios.create({
    baseURL: baseUrl, 
    withCredentials: true, 
    timeout: 86400 * 1000, 
    headers: {
      'Content-Type': 'application/json'
    }
  })
  service.interceptors.request.use(
    config => {
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
  
  service.interceptors.response.use(
    response => {
      const res = response.data
      return res
    },
    error => {
      return Promise.reject(error)
    }
  )
  export default service